import React, { createContext, useState } from 'react'


export const Store = createContext();

function DataStore(props) {
  const [data, setData] = useState([
    {
      id: '16',
      category: "mixer",
      heading: "Vicky Kaushal has 'evolved beautifully' after getting married to Katrina Kaif: Couldn't have asked for...",
      image: "https://www.pinkvilla.com/images/2023-07/1202613865_vicky-katrina-1.jpg",
      description: "Vicky Kaushal and Katrina Kaif are one of the most adorable couples in Bollywood. After dating secretly for a few years, Vicky and Katrina tied the knot in a dreamy wedding ceremony in Rajasthan in 2021. As their wedding was a hush-hush affair, Vicky and Katrina's royal nuptials were attended only by their families and close friends"
    },
    {
      id: '17',
      category: "mixer",
      heading: "Paul Reubens, best known for his character Pee-wee Herman, dies from cancer at 70",
      image: "https://www.hindustantimes.com/ht-img/img/2023/08/01/400x225/Paul_Reubens_1690854829417_1690854829671.jpg",
      description: "Paul Reubens, the actor and comedian whose character Pee-wee Herman became a cultural phenomenon through films and TV shows, has died. He was 70. He died Sunday night after a six-year struggle with cancer that he did not make public, his publicist said in a statement."
    }
    ,
    {
      id: '18',
      category: "mixer",
      heading: "What are semiconductors and how are they used?",
      image: "https://ichef.bbci.co.uk/news/820/cpsprodpb/DAC3/production/_130630065_gettyimages-1267327926.jpg",
      description: "The government has announced a new panel to steer the UK's semiconductor industry, which it describes as vitally important for the modern world we live inAround the world, governments have been taking action, passing new laws and spending huge sums of money to boost the sector in their own countries.Let's take a closer look at what semiconductors are and why they are so important."
    }
    ,
    {
      id: '19',
      category: "Home",
      heading: "MacBook: Would you pay $400 for two more inches?",
      image: "https://content.api.news/v3/images/bin/606f1d8815dff6787eb9eb158ca6bff0?width=650",
      description: "Apple has added yet another laptop to its extensive line-up with the 15-inch Macbook Air. Essentially, this is a larger version of the popular Macbook Air 13 inch, but are there any hidden benefits to the bigger screen model? Or is it just a small luxury that comes in at a higher price point?"
    }
    ,
    {
      id: '20',
      category: "Home",
      heading: "Barbie casting director reveals stars who turned down Ken roles",
      image: "https://content.api.news/v3/images/bin/3cf9bf4f8184eec397559f00f0a2c572?width=650",
      description: "The casting director for box office smash Barbie has opened up about the Hollywood actors who turned down the opportunity to play one of the films many Kens.Ryan Gosling has already earned widespread praise as the main Ken alongside Margot Robbies Barbie, while Simu Liu, Ncuti Gatwa and Kingsley Ben-Adir also appear as other iterations of the male dolls According to Allison Jones, Schitts Creek star Dan Levy, Dear Evan Hansens Ben Platt and Saturday Night Live comedian Bowen Yang were also approached about being in Barbie"
    }
    ,
    {
      id: '21',
      category: "Home",
      heading: "Gaming disorder: Gamers may be seeing things that arent there",
      image: "https://content.api.news/v3/images/bin/0520ca6ed682c39beb6cd9d859ee9f92",
      description: "Hardcore gamers are at risk of developing a disorder that causes them to hallucinate experiences from video games they are playing, shocking new research has revealed."
    }
    ,
    {
      id: '22',
      category: "Home",
      heading: "Elon Musk reveals radical Twitter rebranding",
      image: "https://imageresizer.static9.net.au/2mUJxUPfj1RVtUCWh6kx04N3HgI=/0x172:3000x1859/456x257/https%3A%2F%2Fprod.static9.net.au%2Ffs%2Fe3115939-09d9-4e9c-b9f6-f03c4338dd40",
      description: "The Twitter website now features the same logo, while the familiar blue bird is gonePreviously, Musk said he was bidding adieu to the twitter brand and, gradually, all the birdsTwitter, founded in 2006, has used its vivid, globally recognised blue bird emblem for more than a decade."
    }
    , {
      id: '23',
      category: "mixer",
      heading: "Want deep-fried cheese with that? Macca's Cheesy range returns with a hot new item",
      image: "https://img.delicious.com.au/WAwkyKDt/w759-h506-q80-cfill/del/2023/07/mcdonalds-cheesy-range-source-supplied-193395-2.jpg",
      description: "Theres little in this world that cant be improved with a little cheese. From humble toasties and solo girl dinners to dreamy cheesecakes and perfect pastas, the addition of cheese can always transform any ordinary dish into something special.In recognition of the important role that cheese plays in the realms of winter comfort food, McDonalds is now bringing back its Cheesy range as part of its winter menu. The Cheesy range will include the brand-new Cheesy Angus, along with the returning Cheesy Chicken and Cheesy Beef. All burgers feature a crispy melting mozzarella cheese patty, along with a slice of Aussie jack cheese. "
    }
    , {
      id: '24',
      category: "Home",
      heading: "Nominate the best eats and treats in your state for this year's delicious. 100",
      image: "https://img.delicious.com.au/Oyj_Fque/w759-h506-cfill/del/2023/07/delicious-100-the-best-of-the-best-192970-2.jpg",
      description: "The delicious. 100 is back with a whole new look in 2023. This year, were on the hunt for the best of the best in classic eats and treats across NSW, Queensland, South Australia, Victoria and  for the first time  Tasmania. And we want you to help us!"
    }
    , {
      id: '25',
      category: "Home",
      heading: "Cadbury has released a retro-inspired Caramilk Slices block",
      image: "https://img.delicious.com.au/BVMd4bqO/w759-h506-cfill/del/2023/08/cadbury-caramilk-slice-193513-1.jpg",
      description: "New snack alert! The latest in the Cadbury Slices range has dropped and this one is a doozy: the Cadbury Caramilk Slices Caramel SliceInspired by the top-tier bakery classic, the caramel slice, this mashup of Caramilk chocolate, flowing caramel, vanilla cream and chocolate biscuit pieces is ringing the late-night-snack bell and were here to answer the c"
    }
    , {
      id: '26',
      category: "Home",
      heading: "Kudmayi: Details you might have missed in the wedding song from RRKPK, including the 'kanyadaan' scene",
      image: "https://www.hindustantimes.com/ht-img/img/2023/08/03/400x225/Kudmayi_1691062113510_1691062113806.jpg",
      description: "The soothing number, composed by Pritam and written by Amitabh Bhattacharya, is sung by Shahid Mallya. In the video, the wedding of Rocky (Ranveer) and Rani (Alia) takes place in the presence of their family. In one scene, Alia's onscreen father, played by Tota Roy Chowdhury, kisses her palms and helps her wear the jewellery and her wedding veil. Meanwhile, Ranveer turns emotional as he is helped by his parents to get ready for the wedding."
    }
    , {
      id: '27',
      category: "mixer",
      heading: "Trump sued Michael Cohen for $500 million. Now he's worried he's at risk of self-incrimination",
      image: "https://s.yimg.com/ny/api/res/1.2/hzdNHIdbTIKRj2TufrCftg--/YXBwaWQ9aGlnaGxhbmRlcjt3PTEyNDI7aD04Mjg7Y2Y9d2VicA--/https://media.zenfs.com/en/salon_articles_879/2f39584f2bccbbe47827fdf4922ce59e",
      description: "Former President Donald Trump expressed concern that evidence his former lawyer, Michael Cohen, sought in the $500 million lawsuit he filed against Cohen could potentially incriminate him in any of his other ongoing cases."
    }
    , {
      id: '28',
      category: "mixer",
      heading: "Former Fox News Reporter Ordered by Judge to Reveal Anonymous Source",
      image: "https://s.yimg.com/ny/api/res/1.2/w72QXTY8kZSJbo6U47ZK7A--/YXBwaWQ9aGlnaGxhbmRlcjt3PTIwNDg7aD0xMTUyO2NmPXdlYnA-/https://media.zenfs.com/en/thewrap.com/59cee8345c158b38e68fc9b911303ff3",
      description: "A former Fox News reporter was ordered by a federal judge to reveal the identity of a confidential source, a highly unusual case of a plaintiffs right to legal discovery being placed above the First Amendment protections of a journalist."
    }
    ,
    {
      id: '29',
      category: "Home",
      heading: "Supermoon puts on a dazzling display across the world",
      image: "https://media-cldnry.s-nbcnews.com/image/upload/t_fit-1000w,f_auto,q_auto:best/rockcms/2023-08/230802-italy-supermoon-mb-1002-6abb73.jpg",
      description: "The first of two supermoons expected this month put on a dazzling display Tuesday night, with photographers around the world capturing the lunar spectacle."
    }
    ,
    {
      id: '30',
      category: "Home",
      heading: "Voyager 2: Nasa picks up 'heartbeat' signal after sending wrong command",
      image: "https://ichef.bbci.co.uk/news/976/cpsprodpb/D9F9/production/_104710855_1977_august_september_voyager1_1.jpg.webp",
      description: "Nasa has picked up a signal from its Voyager 2 probe after it lost contact with it billions of miles away from Earth, the space agency said.Last month, the spacecraft - exploring the universe since 1977 - tilted its antenna to point two degrees away from Earth after a wrong command was sentAs a result, the probe stopped receiving commands or sending data."
    }
    ,
    {
      id: '1',
      category: "Bollywood",
      heading: "Vicky Kaushal has 'evolved beautifully' after getting married to Katrina Kaif: Couldn't have asked for...",
      image: "https://www.pinkvilla.com/images/2023-07/1202613865_vicky-katrina-1.jpg",
      description: "Vicky Kaushal and Katrina Kaif are one of the most adorable couples in Bollywood. After dating secretly for a few years, Vicky and Katrina tied the knot in a dreamy wedding ceremony in Rajasthan in 2021. As their wedding was a hush-hush affair, Vicky and Katrina's royal nuptials were attended only by their families and close friends",
    },
    {
      id: '2',
      category: "Bollywood",
      heading: "Farhan Akhtar and Ritesh Sidhwanis Mirzapur to be made into a film; Details Inside",
      image: "https://www.pinkvilla.com/images/2023-07/1588310136_farhan-akhtar-and-ritesh-sidhwanis-mirzapur-to-be-made-into-a-film.jpg",
      description: "After the success of Farhan Akhtar and Ritesh Sidhwanis Excel Entertainment and Prime Video backed Mirzapur 1 and 2, fans have been eagerly waiting for the third part of the franchise, which will feature Pankaj Tripathi, Ali Fazal and Shweta Tripathi in pivotal roles. The first season was unveiled in November 2018,"
    }
    , {
      id: '3',
      category: "Bollywood",
      heading: "Akshay Kumar announces OMG 2 Teaser release date with powerful video; Fans say 'masterpiece loading'",
      image: "https://www.pinkvilla.com/images/2023-07/1950543887_omg-2-teaser-2.jpg",
      description: "Akshay Kumar, Pankaj Tripathi, and Yami Gautam are all set to be seen in the upcoming film, OMG 2. The film is a sequel to Akshay and Paresh Rawal's hit film, Oh My God which was released in 2012. The expectations from the second installment are huge "
    }
    , {
      id: '4',
      category: "Bollywood",
      heading: "Sanjay Dutt and Arshad Warsi to replace Nana Patekar and Anil Kapoor in Welcome 3",
      image: "https://www.pinkvilla.com/images/2023-07/1584256880_sanju-arshad.jpg",
      description: "The Anees Bazmee-directed Welcome is among the most iconic comedies of Indian Cinema that also led to the rise of two cult characters Uday Shetty and Majnu Bhai  played to perfection by Nana Patekar and Anil Kapoor. "
    }
    , {
      id: '5',
      category: "Bollywood",
      heading: "Bigg Boss OTT 2: Salman Khan gets called out on social media by angry fans of Elvish Yadav after the YouTuber sheds buckets on the show",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/07/FotoJet-2023-07-30T005945.351-1.jpg?impolicy=Medium_Widthonly&w=1280&h=900",
      description: "Bigg Boss OTT 2 is mainly driven by fans of two YouTubers Elvish Yadav and Abhishek Malhan. Tonight in the weekend ka vaar, Salman Khan lashed out at the housemates. He scolded Bebika Dhurve for losing control and saying bad things to Manisha Rani. She had said that Manisha Rani is always craving for male company. The two ladies had a dirty fight in the angel and devil task. Later, Manisha Rani along with Abhishek Malhan and Elvish Yadav abused Bebika Dhurve."
    },
    
     {
      id: '104',
      category: "Bollywood",
      heading: "Bigg Boss OTT 2: Salman Khan gets called out on social media by angry fans of Elvish Yadav after the YouTuber sheds buckets on the show",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/07/FotoJet-2023-07-30T005945.351-1.jpg?impolicy=Medium_Widthonly&w=1280&h=900",
      description: "Bigg Boss OTT 2 is mainly driven by fans of two YouTubers Elvish Yadav and Abhishek Malhan. Tonight in the weekend ka vaar, Salman Khan lashed out at the housemates. He scolded Bebika Dhurve for losing control and saying bad things to Manisha Rani. She had said that Manisha Rani is always craving for male company. The two ladies had a dirty fight in the angel and devil task. Later, Manisha Rani along with Abhishek Malhan and Elvish Yadav abused Bebika Dhurve."
    },
    {
      id: '6',
      category: "Bollywood",
      heading: "Bawaal movie review: Varun Dhawan and Janhvi Kapoor film has its heart in the right place but...",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/07/bawal-2.jpg?impolicy=Medium_Widthonly&w=1280&h=900",
      description: "Bawaal is the latest offering by Amazon Prime Video. Starring Varun Dhawan and Janhvi Kapoor, it is a romantic film with a pinch of comedy and much more. It is helmed by Dangal and Chhichhore maker Nitesh Tiwari. It is for the first time that Varun Dhawan and Janhvi Kapoor have been paired together in a film"
    },
     {
      id: '7',
      category: "Bollywood",
      heading: "Kangana Ranaut makes new shocking revelations, attacks 'womaniser superstar' and 'papa ki pari'",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/07/Kangana-Ranaut-Ranbir-Kapoor-Alia-Bhatt-Raha-Kapoor2.png?impolicy=Medium_Widthonly&w=303",
      description: "Kangana Ranaut is on a rant again. She has yet again attacked two of the Bollywood superstars and a papa ki pari. Kangana Ranaut has also attacked film mafia and reached out to cyber crime, read on to know more."
    },
     {
      id: '8',
      category: "Bollywood",
      heading: "Kangana Ranaut slams Karan Johar for wasting Rs 250 crores on Rocky Aur Rani Kii Prem Kahaani; gives THIS advice to Ranveer Singh",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/07/Kangana-Ranaut-Rocky-Aur-Rani-Kii-Prem-Kahaani-Karan-Johar-Ranveer-Singh.png?impolicy=Medium_Widthonly&w=303",
      description: "Kangana Ranaut has taken to her social handle and slammed Karan Johar for making Rocky Aur Rani Kii Prem Kahaani. She also has given a piece of her mind to Ranveer Singh. Check out the Instagram stories of the actress below:"
    },
     {
      id: '9',
      category: "Bollywood",
      heading: "Disha Patani moves on from her breakup with Tiger Shroff, confirms relationship with Aleksander; introduces him as her boyfriend in this viral video",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/08/sussannee-7.png?impolicy=Medium_Widthonly&w=420",
      description: "Watch the video of Disha Patani introducing Aleksander Alexilic as her boyfriend, netizens disapprove as they are still NOT over her separation with Bollywood tar Tiger Shroff."
    },
    {
      id: '10',
      category: "Bollywood",
      heading: "Bigg Boss OTT 2: Salman Khan schools Abhishek Malhan over his 'arrogance'; Elvish Yadav fans call Fukra Insaan 'dogla' for THIS reason",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/08/Abhishek-Malhan-1.png?impolicy=Medium_Widthonly&w=420",
      description: "Bigg Boss OTT 2 Weekend Ka Vaar episode with Salman Khan always grabs a lot of attention. The host and dost of the show properly schools the contestants over whatever transpired inside the house. Today, it was Abhishek Malhan aka Fukra Insaan's turn. He was on the hot seat as Salman Khan schooled him over his comments on leading the show and about his massive fan following. Salman Khan said that whatever Abhishek Malhan said did not come across well. "
    },
    {
      id: '11',
      category: "Bollywood",
      heading: "Samantha Ruth Prabhu HITS BACK at reports claiming she took financial help of Rs 25 crore for myositis treatment; 'I can easily take...'",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/08/Samantha-12.png?impolicy=Medium_Widthonly&w=1280&h=900",
      description: "Samantha Ruth Prabhu is one of the most established actresses of South cinema. She has proved to be one of the finest actresses. Film after film, she has proved her mettle. However, the actress has now taken a break for a short while from work to concentrate on her health."
    },
    {
      id: '12',
      category: "Bollywood",
      heading: "Barun Sobti reveals how Asur changed his life, says, 'People take me more seriously now' [EXCLUSIVE]",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/07/images-13.png?impolicy=Medium_Widthonly&w=1280&h=900",
      description: "Barun Sobti is currently enjoying the best phase of his career. He is killing it on OTT. One of the biggest highlights of his career is Asur series. Starring him, Arshad Warsi, Ridhi Dogra, Anupriya Goenka and others, Asur is one successful series that got everyone talking. "
    },
    {
      id: '13',
      category: "Bollywood",
      heading: "Chandramukhi 2: Kangana Ranaut's first look from the horror-comedy leaves fans breathless",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/08/00000009-7.jpeg?impolicy=Medium_Widthonly&w=420",
      description: "Chandramukhi 2, directed by P Vasu, is a sequel to the Tamil horror comedy movie Chandramukhi. Kangana will play the part of a dancer in the movie."
    },
    {
      id: '14',
      category: "Bollywood",
      heading: "Vijay Varma celebrates one year of Darlings; shares pictures with Alia Bhatt, says, Thank you Darlings, for making me your Darling",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/08/WhatsApp-Image-2023-08-05-at-18.11.21.jpeg?impolicy=Medium_Widthonly&w=420",
      description: "Darlings completes one year: Celebrating one year of Vijay Varma and Alia Bhatt and their honest performance in the film."
    },
    {
      id: '15',
      category: "Bollywood",
      heading: "War 2: Sharvari gets into intense action prep for YRF Spy Universe with Hrithik Roshan and Jr NTR?",
      image: "https://st1.bollywoodlife.com/wp-content/uploads/2023/04/Sharvari-Wagh.jpg?impolicy=Medium_Widthonly&w=303",
      description: "Sharvari Wagh drops a video of her intense training that hints at War 2 after rumours claim that she will join Hrithik Roshan and Jr. NTR in YRF spy universe."
    },

    {
      id: '31',
      category: "Hollywood",
      heading: "Miley Cyrus Opens Up About Her Ideal Partner for the Future",
      image: "https://hushmoores.com/wp-content/uploads/2023/07/miley-cyrus-dating-timeline-4.png",
      description: "Miley Cyrus, now single again, is openly discussing her criteria for a future partner following her recent breakups. The 27-year-old singer had a decade-long on-and-off relationship with ex-husband Liam Hemsworth and a brief fling with The Hills Kaitlynn Carter. After parting ways with Kaitlynn, Miley entered a 10-month relationship with singer Cody Simpson, which has also ended."
    }
    ,
    {
      id: '32',
      category: "Hollywood",
      heading: "5 Lahaina residents files lawsuit against Hawaiian Electric for  Maui wildfire",
      image: "https://www.hindustantimes.com/ht-img/img/2023/08/16/400x225/HAWAII-WILDFIRES--25_1692174490246_1692174536773.JPG",
      description: "The lawsuit claims that the company was “a substantial factor” in the worst U.S. wildfire in more than 100 years and that it should be liable for “negligence, trespass, and nuisance."
    }
    ,
    {
      id: '33',
      category: "Hollywood",
      heading: "Billie Eilish Flashes Diamond Tooth Gems In Wild New Instagram Post",
      image: "https://w0.peakpx.com/wallpaper/120/442/HD-wallpaper-billie-eilish-billie-eilish-thumbnail.jpg",
      description: "Billie Eilish stunned fans yet again with another set of edgy pics on Instagram! In the fourth pic of the Aug. 14 carousel, the “Bad Guy” singer, 21, flashed a big smile, and appeared to have a gold capped tooth, as well as a prominent diamond tooth gem wedged in between her front, top teeth. "
    }
    ,
    {
      id: '83',
      category: "Hollywood",
      heading: "Courtney Anne Mitchells Health Issues: Everything To Know About Corey Feldmans Ex & Her Condition",
      image: "https://hollywoodlife.com/2023/08/15/dua-lipa-bikini-top-sheer-shirt-greece-photos/",
      description: "The singer also wore several other swimsuits as she hung out on a boat and walked around beaches in the gorgeous location."
    }
    , {
      id: '35',
      category: "Hollywood",
      heading: "‘Teen Moms Jenelle Evans Son Jace, 14, Safe After Being Reported As A Runaway",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/08/jenelle-evans-son-jace-as-runaway-ss-fr.jpg?resize=768%2C432",
      description: "Jace has been found, and is safely at home with Jenelle and his family, thank you to the Brunswick Co. Sheriffs Department and to everyone else for their concerns,” Jenelles rep confirmed to TMZ in a statement soon after officials confirmed that her son had been located. "
    }
    , {
      id: '36',
      category: "Hollywood",
      heading: "Nick Jonas Falls Mid-Song While Performing On Jonas Brothers Tour In Boston: Watch",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/08/nick-jonas-falls-mid-fall-while-performing-ss-ftr.jpg?resize=768%2C432",
      description: "Nick Jonas, 30, slipped on stage and fell backwards, during a show at TD Garden in Boston, MA on Tuesday. The singer was performing on the Jonas Brothers Five Albums One Night tour, alongside his brothers Kevin Jonas and Joe Jonas, "
    }
    , {
      id: '37',
      category: "Hollywood",
      heading: "Rachel Zegler Cryptically Responds To Snow White Movie Backlash:  Hope The World Becomes Kinder",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/08/rachel-zegler-snow-white-controversy-vertical.jpg?w=300",
      description: "Rachel Zeglers past comments about the new Snow White live-action movie have divided the internet, and the Golden Globe winner seemingly addressed the controversy in new messages."
    }
    , {
      id: '38',
      category: "Hollywood",
      heading: "Fantastic Four Cast: Everything We Know So Far About The Remake",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/08/fantastic-four-vanessa-kirby-joseph-quinn-vertical.jpg?w=300",
      description: "Fantastic Four casting rumors have taken over the internet. So, whos supposedly in the running? Here are all the latest updates about Marvels highly-anticipated remake."
    }
    , {
      id: '39',
      category: "Hollywood",
      heading: "Meg Ryans Son Jack Quaid Breaks Silence On Johnny Storm & Fantastic Four Casting Rumor",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/08/jack-quaid-breaks-silence-ss-vertical.jpg?w=300",
      description: "Meg Ryans son Jack Quaid took to social media to address rumors of a potential role in the next ‘Fantastic Four!"
    }
    , {
      id: '40',
      category: "Hollywood",
      heading: "Harry Potter Stars Then & Now: See How Cast Has Grown Through The Years",
      image: "https://hollywoodlife.com/wp-content/uploads/2019/07/harry-potter-then-now-2-vertical-1.jpg?w=300",
      description: "Check out photos of Harry Potter stars like Daniel Radcliffe, Emma Watson, and Rupert Grint from the films first release to now!"
    }
    , {
      id: '41',
      category: "Hollywood",
      heading: "Chase W. Dillon: 5 Things To Know About The 13-Year-Old Breakout Star Of  Haunted Mansion",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/07/Chase-Dillon-haunted-manision-vert.jpg?w=300",
      description: "Chase W. Dillon steals the show as youngster Travis in Disneys Haunted Mansion. Get to know this rising star."
    }
    , {
      id: '42',
      category: "Hollywood",
      heading: "BTS Singer Jimin Plays Ryan Goslings Ken Guitar From Barbie After Actor Gifted It To Him: Watch",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/07/ryan-gosling-jimin-guitar-barbie-ken-vertical.jpg?w=300",
      description: "Does the K in K-Pop stand for Ken? A week after Ryan Gosling gave Jimin the guitar from the Barbie movie, the BTS member thanked him for the heartfelt gift"
    }
    , {
      id: '43',
      category: "Hollywood",
      heading: "The Exorcist: Believer Cast, First Trailer & Everything Else To Know About The Horror Sequel",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/07/The-Exorcist-Believer-cast-vertical.jpg?w=300",
      description: "Its been 50 years since The Exorcist became one of the most iconic horror films of all time. A new chapter is beginning with The Exorcist: Believer. Heres what you need to know about the upcoming sequel."
    }
    , {
      id: '44',
      category: "Hollywood",
      heading: "Happy Birthday Daniel Radcliffe: Celebrate The Harry Potter Stars 34th Birthday With Photos From His Young Days & On",
      image: "https://hollywoodlife.com/wp-content/uploads/2022/07/daniel-radcliffe-through-the-years-ss-gal-ftr.jpg?w=300",
      description: "Daniel Radcliffe is 34! Check out photos of the Harry Potter star from throughout his career here."
    }
    , {
      id: '45',
      category: "Hollywood",
      heading: "Hairspray Cast: Where Are They Now? Updates On Zac Efron, Amanda Bynes & More After 16 Years",
      image: "https://hollywoodlife.com/wp-content/uploads/2023/07/Hairspray-Cast-Through-The-Years-vert.jpg?w=300",
      description: "You cant stop this beat! The 2007 film adaptation of Hairspray remains a musical classic. So, where is the cast today? Get updates on all your favorite Hairspray stars."
    }
    ,
    {
      id: '46',
      category: "Techno",
      heading: "Gadgets $400 price hike for tiny detail",
      image: "https://content.api.news/v3/images/bin/606f1d8815dff6787eb9eb158ca6bff0?width=150",
      description: "With the latest MacBook Air upgrade, theres only a few inches in it and it costs a lot of money, says tech expert Elly Awesome."
    }
    ,
    {
      id: '47',
      category: "Techno",
      heading: "Shocking: Customers tricked by tech giant",
      image: "https://content.api.news/v3/images/bin/828f99243ec3b9175c2ae5264a88935b?width=150",
      description: "A tech company deliberately misled customers about discount prices, a court has found."
    },
    {
      id: '48',
      category: "Techno",
      heading: "Really special: Apples new product wows",
      image: "https://content.api.news/v3/images/bin/96b0ed0f296a66a271ccefb259908d8c?width=150",
      description: "Apple has released two new products and one of them in particular is “really special”, with some incredible features."
    },
    {
      id: '49',
      category: "Techno",
      heading: "Ridiculous features of Apples new release",
      image: "https://content.api.news/v3/images/bin/77df017f72cb3efbd94fd13647299332?width=150",
      description: "Apples latest laptop may have a hefty price tag but Elly Awesome was blown away by its performance, display, sound quality and battery life."
    },
    {
      id: '50',
      category: "Techno",
      heading: "Internet Explorer shuts down after 27 years",
      image: "https://content.api.news/v3/images/bin/eeb78dbb41162dd60cacb3257cbf2c26?width=150",
      description: "The tech giant officially retired Internet Explorer on Wednesday after 27 years - fans have paid their repects to the once popular web browser."
    },
    {
      id: '51',
      category: "Techno",
      heading: "Flipping out: Chinas harsh new ban",
      image: "https://content.api.news/v3/images/bin/3f61a6892fe318157a3e78f7fca16577?width=150",
      description: "China has imposed a strict new ban on one of the most popular activities for young people in the country."
    },
    {
      id: '52',
      category: "Techno",
      heading: "Scary side effect hitting hardcore gamers",
      image: "https://content.api.news/v3/images/bin/ae53c71a57074046372f340d795fb85d?width=650",
      description: "Hardcore gamers are experiencing elements of video games in real life, research has revealed, and Aussies arent immune."
    },
    {
      id: '53',
      category: "Techno",
      heading: "AI recreates clip of Pink Floyd song from recordings of brain activity",
      image: "https://images.newscientist.com/wp-content/uploads/2023/08/14165827/SEI_167626725.jpg?width=900",
      description: "An artificial intelligence has created a passable cover of a Pink Floyd song by analysing brain activity recorded while people listened to the original. The findings further our understanding of how we perceive sound and could eventually improve devices for people with speech difficulties."
    },
    {
      id: '54',
      category: "Techno",
      heading: "Time to move on Mark Zuckerberg slams not serious Elon Musk",
      image: "https://content.api.news/v3/images/bin/0ad3df12901cdc2ba9342d59bb135c87",
      description: "The billionaire Meta boss has not held back in his latest comments slamming Elon Musk as their highly-anticipated super-fight is thrown into doubt."
    },
    {
      id: '55',
      category: "Techno",
      heading: "Mark Zuckerberg: Threads users down by more than a half",
      image: "https://ichef.bbci.co.uk/news/976/cpsprodpb/2A8F/production/_130559801_27fc7ce07f7007e56a3cf6a067822ed37310f8cb.jpg.webp",
      description: "Meta boss Mark Zuckerberg says its new social media platform, Threads, has lost more than half its users.The Twitter rival rocketed to more than 100 million users within five days of its launch earlier this month"
    },
    {
      id: '56',
      category: "Techno",
      heading: "SEC turns its gaze from crypto to AI",
      image: "https://www.artificialintelligence-news.com/wp-content/uploads/sites/9/2023/08/sec-gary-gensler-ai-artificial-intelligence-legal-law-finance-automation-380x253.jpg",
      description: "US Securities and Exchange Commission (SEC) chairman Gary Gensler has announced a shift in focus from cryptocurrency to AI."
    },
    {
      id: '57',
      category: "Techno",
      heading: "Meta bets on AI chatbots to retain users",
      image: "https://www.artificialintelligence-news.com/wp-content/uploads/sites/9/2023/08/ai-meta-chatbots-personas-artificial-intelligence-user-retention-380x253.jpg",
      description: "Meta is planning to release AI chatbots that possess human-like personalities, a move aimed at enhancing user retention efforts."
    },
    {
      id: '58',
      category: "Techno",
      heading: "Explosive growth in AI and ML fuels expertise demand",
      image: "https://www.artificialintelligence-news.com/wp-content/uploads/sites/9/2023/07/ai-careers-artificial-intelligence-talent-machine-learning-jobs-enterprise-research-report-study-380x254.jpg",
      description: "AI and machine learning are reshaping the job landscape, with higher incentives being offered to attract and retain expertise amid talent shortages."
    },
    {
      id: '59',
      category: "Techno",
      heading: "Anthropic launches ChatGPT rival Claude 2",
      image: "https://www.artificialintelligence-news.com/wp-content/uploads/sites/9/2023/07/anthropic-claude-2-llm-large-language-model-ai-artificial-intelligence-chatgpt-1024x637.jpg",
      description: "Anthropic has launched Claude 2, an advanced large language model (LLM) that excels in coding, mathematics, and reasoning tasks."
    },
    {
      id: '60',
      category: "Techno",
      heading: "OpenAI introduces team dedicated to stopping rogue AI",
      image: "https://www.artificialintelligence-news.com/wp-content/uploads/sites/9/2023/07/openai-superalignment-agi-artificial-intelligence-ethics-society-superintelligence-impact-dangers-1024x683.jpg",
      description: "Recently, Geoffrey Hinton  the so-called “Godfather of AI”  expressed his worries about the possibility of superintelligent AI surpassing human capabilities and causing catastrophic consequences for humanity."
    }
    ,
    {
      id: '61',
      category: "Food",
      heading: "Immunity boosters to make you #CoronaSafe",
      image: "https://static.toiimg.com/thumb/msid-74746041,imgsize-82784,width-400,resizemode-4/74746041.jpg",
      description: "Working on immunity. What? While we are busy taking all poss "
    }
    ,
    {
      id: '62',
      category: "Food",
      heading: "Price of milk and sunflower oil starting to fall",
      image: "https://ichef.bbci.co.uk/news/800/cpsprodpb/1343E/production/_130801987_milk_woman_getty.jpg.webp",
      description: "The prices of food staples such as oil and milk are final even though shopping bills remain high, new data suggestsResearch firm Kantar said shoppers paid on average £1.50 for four pints of milk in July, down from £1.69 in March."
    }
    ,
    {
      id: '63',
      category: "Food",
      heading: "Upgrades to modernise Victorias grain growers",
      image: "https://www.foodmag.com.au/wp-content/uploads/2023/08/shutterstock_1736891798-600x320.jpg",
      description: "The Victorian state government is set to fast-track cereal, oilseed and pulse crop improvements by transforming the Australian Grains Genebank …"
    }
    ,
    {
      id: '64',
      category: "Food",
      heading: "Young Henrys unveil their new Brewers B- Side",
      image: "https://www.foodmag.com.au/wp-content/uploads/2023/08/Screenshot-2023-08-14-at-1.26.05-pm-600x320.png",
      description: "Newtown brewers and distillers, Young Henrys have launched its latest Brewers B-Side, the Phantasmic Mr Hops, an experimental IPA which …"

    }
    ,
    {
      id: '65',
      category: "Food",
      heading: "18 Best Vegetarian Dinner Recipes| 18 Easy Dinner Recipes",
      image: "https://c.ndtvimg.com/2020-09/if4pp5j8_vegetarian_625x300_30_September_20.jpg",
      description: "Vegetarian Dinner Recipes: Find here list of 17 best vegetarian dinner recipes from makhani paneer biryani, masala bhindi, vegetarian burritos, vegetarian khow suey to dal makhani and many more with key ingredients and how to make process."
    }
    ,
    {
      id: '66',
      category: "Food",
      heading: "Have burgers & chips for lunch? Eating junk food can worsen your asthma that afternoon",
      image: "https://img.etimg.com/thumb/msid-102101766,width-650,height-488,imgsize-118182,,resizemode-75/burger_getty.jpg",
      description: "NEWCASTLE: Certain foods or dietary patterns are linked with better control of your asthma. Others may make it worse. Depending on what you've eaten, you can see the effects in hours"
    }
    ,
    {
      id: '67',
      category: "Food",
      heading: "This Gurugram restaurant has your traditional favourites in fusion style",
      image: "https://akm-img-a-in.tosshub.com/indiatoday/images/story/202303/befunky-collage_1_2-one_one.jpg?VersionId=uU602mqbRGJQWVSQpLTKb9SsmYEs4fVT&size=115:115",
      description: "Anardana brings a number of your traditional favourites together but with a twist. That is brilliantly factored in through lots of fusion between"
    }
    ,
    {
      id: '68',
      category: "Food",
      heading: "Delicious delicacies",
      image: "https://akm-img-a-in.tosshub.com/indiatoday/images/story/201810/28Zest-03-8-647.jpeg?size=690:388",
      description: "Pinch of Spice is an exclusive fine dining restaurant with four outlets, of which two are in Agra and one in Delhi, whereas Bon Barbecue has two outlets, one in Agra and the other in Delhi. "
    }
    ,
    {
      id: '69',
      category: "Food",
      heading: "Baahubali Prabhas is the name of the cocktail being served at this food pop-up",
      image: "https://akm-img-a-in.tosshub.com/indiatoday/images/story/201805/story__1_.jpeg?size=115:115",
      description: "This food pop-up dispels the myth that South Indian food is all about dosa and idli."
    }
    ,
    {
      id: '70',
      category: "Food",
      heading: "Beat the heat with this healthy mango chia pudding | Recipe here",
      image: "https://akm-img-a-in.tosshub.com/indiatoday/images/story/202306/mango_chia_pudding_recipe-sixteen_nine.png?VersionId=tjZ_j6Rqt_WBjbWRnwoQzxvV1_mwS6gc&size=690:388",
      description: "This summer, try this delicious yet health breakfast recipe that includes mangoes and chia seeds."
    }
    ,
    {
      id: '71',
      category: "Fitness",
      heading: "Exploring The Deep Connection Between Mindfulness And Physical Health, Expert Weighs In",
      image: "https://images.news18.com/ibnlive/uploads/2023/08/untitled-design-43-2-16919898993x2.png?impolicy=website&width=510&height=356",
      description: "Mindfulness is a practice rooted in ancient contemplative traditions and has gained widespread popularity in recent years due to its numerous physical and mental health benefits. The essence of mindfulness lies in being fully present and aware of the present moment without any bias "
    }
    ,
    {
      id: '73',
      category: "Fitness",
      heading: "These 5 Nuts Improve Heart Health and Aid Weight Loss",
      image: "https://images.news18.com/ibnlive/uploads/2023/06/untitled-design-2023-06-10t182746.092-16864018793x2.jpg?impolicy=website&width=510&height=356",
      description: "Nuts are crunchy, filling and nutritious. They are the best snacks and perfect foods to overcome hunger pangs quickly. Nuts are rich in healthy fibre, good fat and plant protein. When added to a dessert, salad, smoothie or a bowl of fruits, nuts can enhance its nutritious value and taste. From Keto to Vegan, nuts are enjoyed with all kinds of diets."
    }
    ,
    {
      id: '74',
      category: "Fitness",
      heading: "World Organ Donation Day 2023: Public Awareness Is The Need Of The Hour For Organ Donation",
      image: "https://images.news18.com/ibnlive/uploads/2023/05/wp-image-256-16832935813x2.jpg?impolicy=website&width=219&height=147",
      description: "Transplant is a proven therapy for organ failure but organ shortage is a challenge. A positive thought for coming forward as voluntary organ donor for own near and dear is doing its bit but time has arrived in India when all of us should take a step forward on this world organ donation day to pledge our organs after death. Even if a person dies, his organs can keep working making so many patients of organ failure live longer."
    }
    ,
    {
      id: '75',
      category: "Fitness",
      heading: "Sanya Malhotra Is Giving The Internet Some Major Fitness Goals, Here Is What You Can Learn From Her",
      image: "https://images.news18.com/ibnlive/uploads/2023/08/untitled-design-43-1-16915030243x2.png?impolicy=website&width=219&height=147",
      description: "Sanya Malhotra has always admitted to the fact that she is a true fitness aficionado and that in every way possible is true. While the actress loves to eat, she makes sure to sweat it right. Sanya has an extremely sorted workout pattern that one can definitely take cues from, whether it is a weekday or through the weekend, this diva never misses out on a day of workout."
    }
    ,
    {
      id: '76',
      category: "Fitness",
      heading: "Malaika Arora Starts Off The Week By Showing The Right Way Of 'Finding Your Balance' Through Yoga, Check Out",
      image: "https://images.news18.com/ibnlive/uploads/2023/08/untitled-design-36-1-16914729813x2.png?impolicy=website&width=219&height=147",
      description: "Malaika Arora is a true blue fitness icon who simply bewilders all with her dedication and love towards the practice of yoga. Whether it is raining cats and dogs or there is just scorching heat, she fights it all to attend her regular yoga sessions and there is something to truly learn from her persistence. She keeps herself motivated no matter what and that is a ver"
    }
    ,
    {
      id: '77',
      category: "Fitness",
      heading: "Study Shows Short Bursts Of Intense Exercise Linked To Reduced Risk Of Cancer",
      image: "https://images.news18.com/ibnlive/uploads/2023/07/10-14-1-16907287353x2.png?impolicy=website&width=219&height=147",
      description: "Just 4-5 minutes of vigorous activity that makes people huff and puff during daily tasks is associated with a lower risk of some cancers by up to 32 per cent, according to a studyThe research, published in the journal JAMA Oncology, used data from wearable devices to track the daily activity of over 22,000 ."
    },
    {
      id: '78',
      category: "Fitness",
      heading: "How to incorporate protein into your diet for muscle-building",
      image: "https://images.indianexpress.com/2023/07/fruits.jpg?resize=450,250",
      description: "According to Dr Shuchin Bajaj, Founder Director, Ujala Cygnus Group of Hospitals, consuming a protein-heavy diet is important for muscle building because protein is essential for muscle growth, repair, and maintenance ."
    }
    ,
    {
      id: '79',
      category: "Fitness",
      heading: 'Watch: Tejasswi Prakash is finding her balance with aerial yoga',
      image: 'https://images.indianexpress.com/2023/08/Tejasswi-Prakash_1200_insta-anshuka.jpg?resize=450,250',
      description: 'Aerial fitness has a special focus on three-dimensional movement, conditioning, and joint rotation and mobility, said fitness expert Garima Goyal'
    }
    ,
    {
      id: '80',
      category: "Fitness",
      heading: 'Zomatos Deepinder Goyal loses 15 kilos in 4 years; experts decode weight loss diet',
      image: 'https://images.indianexpress.com/2023/08/deepinder-goyal_1200_insta.jpg?resize=450,250',
      description: 'Deepinder Goyal was also able to reduce his cholesterol levels and body fat percentage levels in a span of four years'
    }
    ,
    {
      id: '81',
      category: "Fitness",
      heading: 'Kiran Bedi reveals fitness mantra at 74: I have never had samosa, poori, kachori, pakode…',
      image: 'https://images.indianexpress.com/2023/08/kiran-bedi_amit-mehra.jpg?resize=450,250',
      description: 'Sharing some advice for those in their 30s and 40s, Dr Bedi said that it is necessary to first accept whatever situation you are in life and then take the decision to either reject it or change it'
    }
    ,
    {
      id: '82',
      category: "Fitness",
      heading: 'Shibani Dandekar and Farhan Akhtar set partner fitness goals as they workout together',
      image: 'https://images.indianexpress.com/2023/07/shibani_farhan_1200_fotness.jpg?resize=450,250',
      description: 'While Shibani can be seen doing TRX suspension, Farhan can be seen trying to be the Iron Man for her by blowing some air (read: kisses) towards her while bent on one knee.'
    } ,
    {
      id: '72',
      category: "Fitness",
      heading: 'Masaba Gupta performs Mukha Dhauti Kriya to improve breathing, promote recovery: know more about the practice',
      image: 'https://images.indianexpress.com/2023/07/masaba-gupta_-2.jpg?resize=450,250',
      description: 'This kriya is great for those suffering from asthma, bronchitis, frequent colds, sinus issues and headaches, said'
    } ,
    {
      id: '84',
      category: "Fitness",
      heading: 'New mom Gauahar Khan squeezes in a 20-minute workout: know what to consider',
      image: 'https://images.indianexpress.com/2023/07/gauahar-khan_2.jpg?resize=450,250',
      description: 'Consistency is key when it comes to reaping the benefits of a 20-minute workout, said Bala Krishna Reddy Dabbedi, fitness expert, Co-founder and director at FITTR'
    }
    ,
    {
      id: '87',
      category: "Techno",
      heading: "How Shortwave tamed my inbox with smart organisation and a dash of AI",
      image: "https://images.indianexpress.com/2023/08/shortwave-email-featured.jpg?resize=450,250",
      description: "I tried Shortwave, an email app that uses AI to summarise and reply to messages (among other things), and heres what I think."
    },
    {
      id: '90',
      category: "Techno",
      heading: "Samsung to launch Galaxy M34 on July 7: Heres what we know so far",
      image: "https://images.indianexpress.com/2023/06/Galaxy-M34-Amazon.jpg?resize=450,250",
      description: "The Samsung Galaxy M34 will be the first phone in the M series to come with an sAMOLED screen."
    }
    ,
    {
      id: '93',
      category: "Techno",
      heading: "OnePlus Open might be a rebranded Oppo Find N3",
      image: "https://images.indianexpress.com/2023/08/OnePlus-Open-Foldable.jpg?resize=450,250",
      description: "The upcoming foldable phone from OnePlus called Open will most likely be a rebranded version of the Oppo Find N3, a device that will be launched in China later this year."
    }
    ,
    {
      id: '96',
      category: "Techno",
      heading: "Dell launches new G-series gaming laptops with Nvidia RTX 40 series GPU: Check specs, price and other details",
      image: "https://images.indianexpress.com/2023/05/Dell-G15-G16.jpg?resize=450,250",
      description: "Dell's latest G-series gaming laptops come with the company's Game Shift technology and support Dolby Audio"
    }
    ,
    {
      id: '99',
      category: "Techno",
      heading: "Reliance launches JioBook 4G for Rs 16,499",
      image: "https://images.indianexpress.com/2023/07/JioBook.jpg?resize=450,250",
      description: "The laptop runs on JioOS and will go on sale on Amazon and Reliance Digital from August 5.."
    },
    {
      id: '102',
      category: "Fitness",
      heading: "With a throwback picture, trainer reveals how Ranveer Singh managed to look jacked",
      image: "https://images.indianexpress.com/2023/07/ranveer-singh_1200_2016.jpg?resize=450,250",
      description: "Everyone these days is looking for a quick fix. In fact, I can confidently tell you, the faster the results the more likely the method you used will unsustainable in the long-term, shared Lloyd Stevens, fitness trainer and transformation specialis"
    },
    {
      id: '105',
      category: "Fitness",
      heading: "Virat Kohlis go-to exercise is this type of squats; know more",
      image: "https://images.indianexpress.com/2023/07/virat-kohli_200_insta.jpg?resize=450,250",
      description: "Bala Krishna Reddy, co-founder, Fittr said that this simple yet potent exercise offers a holistic approach to fitness."
    },
    {
      id: '111',
      category: "Fitness",
      heading: "Milind Soman kettlebell movement irks fitness enthusiasts; know how to handle it safely",
      image: "https://images.indianexpress.com/2023/07/milind-soman_insaat1.jpg?resize=450,250",
      description: "This one is 10kg and its perfect for me to start with, said Milind Soman in a post on Instagram"
    }


  ])
  return (
    <Store.Provider value={[data, setData]}>
            {props.children}
    </Store.Provider>
  )
}

export default DataStore
